<template>
	<div class="mobile-menu-wrapper">
		<nav v-if="dataLoad">
			<navigation-desctop
				v-if="screenWidth > 639"
				:data-params="menuData"
				:screen-width="screenWidth"
			></navigation-desctop>
			<navigationMobile
				v-else-if="screenWidth <= 639"
				:data-params="menuData"
			>
			</navigationMobile>
		</nav>
	</div>
</template>

<script>
	const navigationDesctop = require('./navigations/navigation-desctop.vue');
	const navigationMobile = require('./navigations/navidation-mobile.vue');
	export default {
		props: {
			dataParams: {
				type: String,
				required: true
			}
		},
		data() {
			return {
				params: {},
				menuData: {},
				screenWidth: window.innerWidth,
				dataLoad: false
			}
		},
		created() {
			this.params = JSON.parse(this.dataParams.replace(/'/g, '"'));
			fetch(this.params.url)
				.then(res => res.json())
				.then( data => {
					this.menuData = data.api_response;
					this.dataLoad = true;
				});
		},
		mounted() {
			this.$nextTick(() => {
				window.addEventListener('resize', () => {
					this.screenWidth = document.documentElement.clientWidth;
					console.log(this.screenWidth);
				});
			});
		},
		components: {
			navigationDesctop,
			navigationMobile
		}
	}
</script>
<style lang="scss">
	@media (max-width: 639px) {
		.mobile-menu-wrapper{
			height: 55px;
			background-color: var(--bg-color);
			border-radius: .25rem;
		}
	}
	
</style>


// WEBPACK FOOTER //
// Navigation.vue?531f18a2